import React from 'react';
import styles from "./SectionMain.module.css";

const SectionMain = () => {
  return (
    <section className={styles.section}>
      <div className={styles.overlayContent}>
        <h1>Hotel</h1>
        <p>Torre Eiffel Atacames</p>
        <h2>SOL, PLAYA Y MUCHO MÁS</h2>
        <a href="https://wa.me/c/593980202185" className="primaryBtn">Reservar Ahora</a>
      </div>
      <video 
        src="/videos/beach.mp4" 
        autoPlay 
        loop 
        muted 
        className={styles.video}>
      </video>
    </section>
  );
};

export default SectionMain;
